// components/company/OrgSwitcher.jsx
import React, { useEffect, useState } from "react";
import { fetchWithAuth } from "../../utils/fetchWithAuth";
import { toast } from "react-hot-toast";

export default function OrgSwitcher({ onChanged }) {
  const [me, setMe] = useState(null);
  const [orgs, setOrgs] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [switching, setSwitching] = useState(false);

  const load = async () => {
    try {
      const meRes = await fetchWithAuth("/api/accounts/me/");
      const orgsRes = await fetchWithAuth("/api/accounts/me/organizations/");
      setMe(meRes || {});
      const list = Array.isArray(orgsRes?.organizations) ? orgsRes.organizations : [];
      setOrgs(list);
      setActiveId(meRes?.active_organization_id || meRes?.organization?.id || null);
    } catch (e) {
      // ignore — page still renders
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleActivate = async (newOrgId) => {
    if (!newOrgId) return;
    setSwitching(true);
    try {
      await fetchWithAuth("/api/accounts/me/organizations/activate/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ organization_id: Number(newOrgId) }),
      });
      setActiveId(Number(newOrgId));
      toast.success("Active organization updated.");
      onChanged?.(Number(newOrgId));
      await load(); // keep header label in sync
    } catch (e) {
      toast.error("Could not switch organization.");
    } finally {
      setSwitching(false);
    }
  };

  if (loading || orgs.length === 0) return null;

  return (
    <div className="flex w-full items-center gap-2 sm:w-auto">
      <label htmlFor="org-switcher-org" className="text-xs text-tertiary">Org</label>
      <select id="org-switcher-org"
        className="min-h-[40px] w-full flex-1 rounded-lg border border-line-control bg-surface px-3 py-2 text-sm text-ink focus:border-brand focus:outline-none [color-scheme:light] disabled:opacity-60 sm:w-auto sm:flex-none"
        value={activeId || ""}
        onChange={(e) => handleActivate(e.target.value)}
        disabled={switching}
      >
        <option value="" disabled>Select…</option>
        {orgs.map((o) => (
          <option key={o.id} value={o.id}>
            {o.name} {o.is_active ? "(active)" : ""}
          </option>
        ))}
      </select>
    </div>
  );
}
